// extracted by mini-css-extract-plugin
module.exports = {"container":"TossPromotionBanner_container__y7xbO"};